import { useCallback, useEffect, useMemo, useState } from "react";
import FormSectionWrapper from "../../../Components/ProForms/FormSectionWrapper";
import ProFormsLayout from "../../../Components/ProForms/ProFormsLayout";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { ProjectProfileConfig, profileFormNames } from "../projectData.js";
import { STAUTES } from "../../../../utils/constant";
import { errorToast, successToast } from "../../../../utils/toastHelper";
import ProjectScheduling from "././ProjectSchedule";
import {
  UPDATE_PROJECT,
  ADD_PROJECT,
  GET_ENVERUS_PROJECTLIST,
  ADD_ENVERUS_PROJECTLIST,
  GET_PROJECT,
  GETALL_WORKTYPE,
  GETALL_PROJECTDOCUMENTTYPE,
  DYNAMIC_DROPDOWN,
  ALL_STATES,
  ALL_COUNTIES,
  ALL_CITIES,
  ALL_ZIP_CODES,
  DELETE_WAGEDETERMINATION_DOCUMENTS,
  UPDATE_WAGEDETERMINATION_FILE_DESCRIPTION
} from "../../../../utils/services/apiPath";
import { postApi, getApi, deleteApi, putApi } from "../../../../utils/services";
import ProjectPartners from "./ProjectPartners.jsx";
import {
  changeMode,
  changeModeForField,
  convertFileToBase64,
  convertResponseDate,
  formatPayloadDate,
  prepareDefaultValues,
  prepareInitialConfig,
  mapWageDeterminationFilesFromResponse,
  buildWageDeterminationSavePayload,
  buildWageDeterminationDescriptionUpdates
} from "../../../../utils/formHelper";
import usePermission from "../../../../utils/customHooks/usePermission";
import useWageDocuments from "../../../../utils/customHooks/useWageDocuments";
import { R_PROJECTS, R_PROJECTS_PROFILE } from "../../../../utils/permissionReferenceConfig";
import { subModPermissionSelector } from "../../../store/features/permissions/permissionsSlice";
import {
  timeKeeping,
  communitySolarOptions,
  coLocatedProjectOptions,
  projectKickoff,
  interconnectionApproval,
  defaultDropdownConfig,
  documentType
} from "../../../../utils/dropdownHelper.js";
import dayjs from "dayjs";
import ProjectNameAndAddressSection from "./ProjectProfile/ProjectNameAndAddressSection.jsx";
import ProjectOwnershipSection from "./ProjectProfile/ProjectOwnershipSection.jsx";
import ProjectDetailsSection from "./ProjectProfile/ProjectDetailsSection.jsx";
import ProjectDetailsRequestedInfoSection from "./ProjectProfile/ProjectDetailsRequestedInfoSection.jsx";
import ProjectSiteModuleInfoSection from "./ProjectProfile/ProjectSiteModuleInfoSection.jsx";
import ProjectSiteStructureInfoSection from "./ProjectProfile/ProjectSiteStructureInfoSection.jsx";
import ProjectSiteInverterDetailSection from "./ProjectProfile/ProjectSiteInverterDetailSection.jsx";
import ProjectSiteInterconnectionInfoSection from "./ProjectProfile/ProjectSiteInterconnectionInfoSection.jsx";
import ProjectSitePermittingEntitlementSection from "./ProjectProfile/ProjectSitePermittingEntitlementSection.jsx";
import ConfirmDialog from "./ProjectProfile/ProDialog.jsx";
import { useFeatureFlagEnabled } from "posthog-js/react";

export default function ProjectProfile() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isAddMode = useMemo(() => id === "add", [id]);
  const [projectProfileData, setProjectProfileData] = useState({});
  const [status, setStatus] = useState(STAUTES.IDLE);
  const [projectId, setProjectId] = useState("");
  const [globalEditMode, setGlobalEditMode] = useState(false);
  const [isCreator, setIsCreator] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [isInitializing, setIsInitializing] = useState(false);
  const [workTypeList, setWorkTypeList] = useState([]);
  const [projectDocumentTypeList, setProjectDocumentTypeList] = useState([]);
  const [clients, setClients] = useState([]);
  const [allStates, setAllStates] = useState([]);
  const [countyOptions, setCountyOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [zipOptions, setZipOptions] = useState([]);
  const [loadingZip, setLoadingZip] = useState(false);
  const [loadingCounty, setLoadingCounty] = useState(false);
  const [loadingCity, setLoadingCity] = useState(false);
  const [enverusProjects, setEnverusProjects] = useState([]);
  const [selectedEnverusProject, setSelectedEnverusProject] = useState({});
  const [projectNameWarning, setProjectNameWarning] = useState("");
  const [open, setOpen] = useState(false);
  const [openWarning, setOpenWarning] = useState(false);
  const [documentFileName, setDocumentFileName] = useState("");
  const [documentUrl, setDocumentUrl] = useState("");
  const [documentPath, setDocumentPath] = useState("");
  const [formConfig, setFormConfig] = useState(prepareInitialConfig(ProjectProfileConfig, isAddMode ? "edit" : "read"));
  const { handleSubmit, control, setValue, watch, trigger, getValues, clearErrors } = useForm({ defaultValues: prepareDefaultValues(ProjectProfileConfig) });

  const {
    wageDocumentsState,
    addFile: addWageDocument,
    changeLabel: changeWageDocumentLabel,
    deleteFile: deleteWageDocument,
    syncFromServer: syncWageDocumentsFromServer,
    discardChanges: discardWageDocumentChanges
  } = useWageDocuments();

  const isProjectWorkAreasEnabled = useFeatureFlagEnabled("is_project_work_areas_enabled");


  const {
    "Project Name and Address": projectInformationNameAndAddressPermission,
    "Project Ownership(Partners)": projectOwnerShipPermission,
    "Project Partners": projectPartnersPermission,
    "Project Details": projectDetailsPermission,
    "Project Details(Required Info)": projectDetailsRequiredInfoPermission,
    "Project Site : Module Info": projectSiteModuleInfoPermission,
    "Project Site : Structure Info": projectSiteStructedInfoPermission,
    "Project Site : Inverter Detail": projectSiteInverterDetailPermission,
    "Project Site : Material & Equipment Scheduling Info": projectSiteMaterialPermission,
    "Project Site : Interconnection Info": projectSiteInterconnectionInfoPermission,
    "Project Site : Permitting & Entitlement Detail": projectSitePermittingAndEntitlementDetailPermission
  } = usePermission(subModPermissionSelector(R_PROJECTS, R_PROJECTS_PROFILE), profileFormNames);

  // Same rule as ProFormsLayout hideEdit: non-creator (e.g. subcontractor) never edits; creator needs at least one profile subsection canEdit.
  const hideProjectProfileEditButton = useMemo(
    () =>
      isCreator
        ? !(
            projectInformationNameAndAddressPermission.canEdit ||
            projectOwnerShipPermission.canEdit ||
            projectPartnersPermission.canEdit ||
            projectDetailsPermission.canEdit ||
            projectDetailsRequiredInfoPermission.canEdit ||
            projectSiteModuleInfoPermission.canEdit ||
            projectSiteStructedInfoPermission.canEdit ||
            projectSiteInverterDetailPermission.canEdit ||
            projectSiteMaterialPermission.canEdit ||
            projectSiteInterconnectionInfoPermission.canEdit ||
            projectSitePermittingAndEntitlementDetailPermission.canEdit
          )
        : true,
    [
      isCreator,
      projectInformationNameAndAddressPermission.canEdit,
      projectOwnerShipPermission.canEdit,
      projectPartnersPermission.canEdit,
      projectDetailsPermission.canEdit,
      projectDetailsRequiredInfoPermission.canEdit,
      projectSiteModuleInfoPermission.canEdit,
      projectSiteStructedInfoPermission.canEdit,
      projectSiteInverterDetailPermission.canEdit,
      projectSiteMaterialPermission.canEdit,
      projectSiteInterconnectionInfoPermission.canEdit,
      projectSitePermittingAndEntitlementDetailPermission.canEdit
    ]
  );

  /** When false, keep fields read-only (matches no Edit/Save for this user). Add flow always allows entry. */
  const canMutateProjectProfile = isAddMode || !hideProjectProfileEditButton;

  const selectedState = watch("state");
  const selectedCounty = watch("primaryCounties");
  const selectedZip = watch("zipCode");
  const isTargetConstructionStartDate = watch("targetConstructionStartDate");
  const [prevState, setPrevState] = useState(undefined);
  const [prevZip, setPrevZip] = useState(undefined);
  const [prevCounty, setPrevCounty] = useState(undefined);

  useEffect(() => {
    const initialValues = [
      [prevState, setPrevState, selectedState],
      [prevZip, setPrevZip, selectedZip],
      [prevCounty, setPrevCounty, selectedCounty]
    ];
    initialValues.forEach(([prev, setter, selected]) => {
      if (prev === undefined && selected) setter(selected);
    });
  }, [selectedState, selectedZip, selectedCounty]);

  const handleDateValidation = date => {
    return date ? dayjs(date).isBefore(dayjs(isTargetConstructionStartDate), "day") : false;
  };


  const isEditModeOn = useMemo(() => Object.values(formConfig).some(({ mode }) => mode === "edit"), [formConfig]);
  const handleReadValueClick = useCallback(
    name => {
      if (!canMutateProjectProfile) return;
      setFormConfig(changeModeForField(name, "edit"));
    },
    [canMutateProjectProfile]
  );
  const backAction = () => navigate("/projects");

  const onEdit = () => {
    if (!isAddMode && hideProjectProfileEditButton) return;
    setGlobalEditMode(true);
    setFormConfig(changeMode("edit"));
  };

  const onCancel = () => {
    if (isAddMode) backAction();
    else {
      setGlobalEditMode(false);
      setFormConfig(changeMode());
      discardWageDocumentChanges();
    }
  };

  const makeFieldAndDependentsEditable = useCallback((fieldName, dependentType) => {
    if (!canMutateProjectProfile) return;
    setFormConfig(prev => {
      const newConfig = { ...prev };
      const setEditable = key => {
        if (newConfig[key]) {
          newConfig[key] = { ...newConfig[key], mode: "edit" };
        }
      };
      const dependencyMap = {
        state: ["zipCode", "primaryCounties", "city"],
        zipCode: ["primaryCounties", "city"],
        primaryCounties: ["city"]
      };
      setEditable(fieldName);
      dependencyMap[dependentType]?.forEach(setEditable);
      return newConfig;
    });
  }, [canMutateProjectProfile]);

  useEffect(() => {
    if (isAddMode || canMutateProjectProfile) return;
    setGlobalEditMode(false);
    setFormConfig(changeMode("read"));
  }, [isAddMode, canMutateProjectProfile]);

  const loadBasicDropdownData = async () => {
    try {
      const endpoints = [
        postApi(GETALL_WORKTYPE, defaultDropdownConfig),
        postApi(GETALL_PROJECTDOCUMENTTYPE, defaultDropdownConfig),
        postApi(DYNAMIC_DROPDOWN, ["PARTNER"]),
        getApi(ALL_STATES)
      ];
      const [workTypes, docTypes, clientsData, statesData] = await Promise.all(endpoints);
      const mapToOptions = (data, labelKey, valueKey) => data?.map(item => ({ label: item[labelKey], value: item[valueKey] })) || [];
      setWorkTypeList(mapToOptions(workTypes.data, "workType", "workTypeId"));
      setProjectDocumentTypeList(mapToOptions(docTypes.data, "projectDocumentType", "projectDocumentTypeId"));
      setClients(clientsData?.[0]?.typeDropDowns || []);
      const parsedStates = Object.entries(statesData || {})
        .map(([key, value]) => ({ label: value, value: key.toUpperCase() }))
        .sort((a, b) => a.label.localeCompare(b.label));

      setAllStates(parsedStates);
    } catch (error) {
      errorToast("Error loading dropdown data");
    }
  };

  const fetchDropdownData = async ({ url, params, onSuccess, onErrorMessage, onFinally }) => {
    try {
      const queryParams = Object.entries(params)
        .filter(([, v]) => v)
        .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
        .join("&");
      const response = await getApi(`${url}?${queryParams}`);
      if (!Array.isArray(response)) throw new Error("Unexpected response format");

      const uniqueValues = Array.from(new Set(response.filter(Boolean)));
      const options = uniqueValues.map(value => ({ label: value, value })).sort((a, b) => a.label.localeCompare(b.label));
      onSuccess(options);
    } catch (error) {
      errorToast(onErrorMessage);
    } finally {
      onFinally?.();
    }
  };

  const fetchZipCodes = async (stateCode, countyName = "") => {
    if (!stateCode || !allStates.length) return;
    setLoadingZip(true);
    const stateName = allStates.find(({ value }) => value === stateCode)?.label;
    if (!stateName) return setLoadingZip(false);
    await fetchDropdownData({
      url: ALL_ZIP_CODES,
      params: { state: stateName, county: countyName },
      onSuccess: setZipOptions,
      onErrorMessage: "Error loading zip codes",
      onFinally: () => setLoadingZip(false)
    });
  };

  const fetchCounties = async (stateCode, zipCode) => {
    if (!stateCode || !zipCode || !allStates.length) return;
    setLoadingCounty(true);
    const stateName = allStates.find(({ value }) => value === stateCode)?.label;
    if (!stateName) return setLoadingCounty(false);
    await fetchDropdownData({
      url: ALL_COUNTIES,
      params: { state: stateName, zipCode },
      onSuccess: setCountyOptions,
      onErrorMessage: "Error loading counties",
      onFinally: () => setLoadingCounty(false)
    });
  };

  const fetchCities = async (stateCode, countyName) => {
    if (!stateCode || !countyName || !allStates.length) return;
    if (!countyOptions.find(c => c.value === countyName)) {
      setCityOptions([]);
      return;
    }
    setLoadingCity(true);
    const stateName = allStates.find(({ value }) => value === stateCode)?.label;
    if (!stateName) return setLoadingCity(false);
    await fetchDropdownData({
      url: ALL_CITIES,
      params: { state: stateName, county: countyName },
      onSuccess: setCityOptions,
      onErrorMessage: "Error loading cities",
      onFinally: () => setLoadingCity(false)
    });
  };

  const clearFields = fields => fields.forEach(fn => fn(""));
  const clearOptions = setters => setters.forEach(fn => fn([]));

  useEffect(() => {
    if (isInitializing) return;
    const stateChanged = selectedState !== prevState && prevState !== undefined;
    const isInitial = selectedState && prevState === undefined;
    if (stateChanged) {
      setPrevState(selectedState);
      if (!selectedState) {
        clearOptions([setCityOptions, setZipOptions, setCountyOptions]);
        clearFields([v => setValue("city", v), v => setValue("zipCode", v), v => setValue("primaryCounties", v)]);
        return;
      }
      clearFields([v => setValue("primaryCounties", v), v => setValue("city", v), v => setValue("zipCode", v)]);
      clearOptions([setCountyOptions, setCityOptions, setZipOptions]);
      fetchZipCodes(selectedState);
    } else if (isInitial) {
      setPrevState(selectedState);
      fetchZipCodes(selectedState);
    }
  }, [selectedState, isInitializing]);

  useEffect(() => {
    if (isInitializing) return;
    const zipChanged = selectedZip !== prevZip && prevZip !== undefined;
    const isInitial = selectedState && selectedZip && prevZip === undefined;
    if (zipChanged) {
      setPrevZip(selectedZip);
      if (!selectedZip) {
        clearFields([v => setValue("primaryCounties", v), v => setValue("city", v)]);
        clearOptions([setCountyOptions, setCityOptions]);
        return;
      }
      clearFields([v => setValue("city", v), v => setValue("primaryCounties", v)]);
      clearOptions([setCityOptions, setCountyOptions]);
      fetchCounties(selectedState, selectedZip);
    } else if (isInitial) {
      setPrevZip(selectedZip);
      fetchCounties(selectedState, selectedZip);
    }
  }, [selectedState, selectedZip, isInitializing]);

  useEffect(() => {
    if (isInitializing) return;
    const countyChanged = selectedCounty !== prevCounty && prevCounty !== undefined;
    const isInitial = selectedState && selectedCounty && prevCounty === undefined;
    if (countyChanged) {
      setPrevCounty(selectedCounty);
      if (!selectedCounty) {
        clearFields([v => setValue("city", v)]);
        clearOptions([setCityOptions]);
        return;
      }
      clearFields([v => setValue("city", v)]);
      clearOptions([setCityOptions]);
      fetchCities(selectedState, selectedCounty);
    } else if (isInitial) {
      setPrevCounty(selectedCounty);
      fetchCities(selectedState, selectedCounty);
    }
  }, [selectedState, selectedCounty, isInitializing]);

  const formatProjectData = data => ({
    ...data,
    projectEPC: data.projectEPCItem?.value || null,
    projectOwner: data.projectOwnerItem?.value || null,
    projectDeveloper: data.projectDevelperItem?.value || null,
    actualConstructionStartDate: convertResponseDate(data.actualConstructionStartDate),
    projectKickoff: data.kickoffSeason,
    firstPowerDate: convertResponseDate(data.firstPowerDate),
    projectLastUpdatedDate: convertResponseDate(data.projectLastUpdatedDate),
    targetConstructionStartDate: convertResponseDate(data.targetConstructionStartDate),
    targetCODDate: convertResponseDate(data.targetCODDate),
    projectAcresSize: data.projectAcres,
    projectCapacityAC: data.acCapacity,
    projectCapacityDC: data.dcCapacity,
    constructionSiteCounties: data.countiesInConstructionSite,
    rowCount: data.tableOrRowCount,
    DCRatio: data.dcRatio,
    ACRatio: data.acRatio,
    ROWRequired: data.isRowRequired,
    projectDocumentType: data?.projectDocumentType?.projectDocumentTypeId,
    primaryCounties: data?.primaryCounties,
    city: data?.city
  });

  const handleDocumentMedia = media => {
    if (media !== null) {
      setDocumentUrl(media.base64String);
      setDocumentFileName(media.fileName);
      setDocumentPath(media.path);
    }
  };

  const ensureLocationOptionsExist = projectData => {
    if (projectData.primaryCounties && !countyOptions.find(c => c.value === projectData.primaryCounties)) {
      setCountyOptions(prev => [...prev, { label: projectData.primaryCounties, value: projectData.primaryCounties }]);
    }
    if (projectData.city && !cityOptions.find(c => c.value === projectData.city)) {
      setCityOptions(prev => [...prev, { label: projectData.city, value: projectData.city }]);
    }
  };

  const loadProjectDataForEdit = async id => {
    setIsInitializing(true);
    try {
      const response = await getApi(`${GET_PROJECT}/${id}`);
      if (response?.error) {
        errorToast(response.error);
        return;
      }
      const data = response?.data ?? response;
      
      const formattedData = formatProjectData(data);
      setProjectProfileData(formattedData);
      setProjectId(data.projectId);
      handleDocumentMedia(data.documentMediaModel);

      try {
        const mappedWageDocuments = mapWageDeterminationFilesFromResponse(data.wageDeterminationDocumentFiles);
        syncWageDocumentsFromServer(mappedWageDocuments);
      } catch (wageDocumentsErr) {
        errorToast("Failed to load wage determination documents.");
      }
      
      await loadBasicDropdownData();
      const { state, zipCode, primaryCounties } = formattedData;
      const stateName = state && allStates.find(({ value }) => value === state)?.label;
      if (stateName) {
        await fetchZipCodes(state, primaryCounties || "");
        if (zipCode) {
          const countiesResponse = await getApi(`${ALL_COUNTIES}?state=${encodeURIComponent(stateName)}&zipCode=${encodeURIComponent(zipCode)}`);
          if (!Array.isArray(countiesResponse)) throw new Error("Unexpected response format");
          const countyOptionsData = countiesResponse.map(name => ({ label: name, value: name })).sort((a, b) => a.label.localeCompare(b.label));
          setCountyOptions(countyOptionsData);
          if (primaryCounties && !countyOptionsData.find(c => c.value === primaryCounties)) {
            setCountyOptions(prev => [...prev, { label: primaryCounties, value: primaryCounties }]);
          }
          if (primaryCounties) {
            await fetchCities(state, primaryCounties);
          }
        }
      }
      ensureLocationOptionsExist(formattedData);
      if (!data.isCreator) {
        setGlobalEditMode(false);
        setFormConfig(changeMode("read"));
        setIsCreator(false);
        if (data.workType) setWorkTypeList([{ label: data.workType.workType, value: data.workType.workTypeId }]);
        if (data.projectDocumentType) {
          setProjectDocumentTypeList([
            { label: data.projectDocumentType.ProjectDocumentType, value: data.projectDocumentType.projectDocumentTypeId }
          ]);
        }
        setClients([data.projectEPCItem, data.projectOwnerItem, data.projectDevelperItem].filter(Boolean));
      }
      Object.keys(formConfig).forEach(field => setValue(field, formattedData[field]));
    } catch (error) {
      errorToast("Error loading project data");
    } finally {
      setIsInitializing(false);
    }
  };

  const loadProjectDataForAdd = async () => {
    onEdit();
    await loadBasicDropdownData();
  };

  const fetchEnverusProjects = useCallback(async searchString => {
    try {
      const { data } = await getApi(`${GET_ENVERUS_PROJECTLIST}?searchString=${searchString}`);
      setEnverusProjects(data?.map(item => ({ label: item.projectName, value: item.envProjectGuid })) || []);
    } catch (error) {
      errorToast("Error fetching Enverus projects");
    }
  }, []);

  const AddNewProjectName = async searchString => {
    if (!searchString) return;
    const trimmedString = searchString.trim();
    setValue("projectName", trimmedString);
    if (trimmedString) {
      const result = await postApi(ADD_PROJECT, { projectName: trimmedString });
      if (result?.error) {
        if (result.statusCode === 409) {
          setProjectNameWarning(trimmedString);
          return setOpenWarning(true);
        }
        return errorToast(result.error);
      }
      if (!result?.projectId) {
        return errorToast("Something went wrong creating the project. Please try again.");
      }
      navigate(`/projects/${result.projectId}`);
    }
  };

  const handleChangeInProjectSelect = (e, value) => {
    setSelectedEnverusProject(value);
    setOpen(true);
  };

  const handleCreateProject = async () => {
    const { error, data } = await postApi(ADD_ENVERUS_PROJECTLIST, {
      envProjectGuid: selectedEnverusProject.value
    });
    if (error) {
      return errorToast(error);
    }
    if (!data?.projectGuid) {
      return errorToast("Something went wrong creating the project. Please try again.");
    }
    navigate(`/projects/${data.projectGuid}`);
    setOpen(false);
    setSelectedEnverusProject({});
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedEnverusProject({});
  };

  const handleWarningClose = () => {
    setOpenWarning(false);
  };

  const onSubmit = async _values => {
    if (isSaving) return;
    setIsSaving(true);
    setStatus(STAUTES.LOADING);
    if (typeof _values.state === "string") _values.state = _values.state.trim();
    const payload = {
      ..._values,
      projectAcres: _values.projectAcresSize,
      countiesInConstructionSite: _values.constructionSiteCounties,
      primaryCounties: _values.primaryCounties,
      workId: _values.workId,
      targetConstructionStartDate: formatPayloadDate(_values.targetConstructionStartDate),
      actualConstructionStartDate: formatPayloadDate(_values.actualConstructionStartDate),
      targetCODDate: formatPayloadDate(_values.targetCODDate),
      kickoffSeason: _values.projectKickoff,
      acCapacity: _values.projectCapacityAC,
      dcCapacity: _values.projectCapacityDC,
      tableOrRowCount: _values.rowCount,
      dcRatio: _values.DCRatio,
      acRatio: _values.ACRatio,
      isRowRequired: _values.ROWRequired,
      projectDocumentTypeId: _values.projectDocumentType,
      coLocatedProject: _values.coLocatedProject || null,
      firstPowerDate: formatPayloadDate(_values.firstPowerDate),
      projectLastUpdatedDate: formatPayloadDate(_values.projectLastUpdatedDate),
      projectId
    };

    delete payload.wageDeterminationDocumentFile;

    if (documentFileName) {
      payload.documentMediaModel = {
        base64String: documentUrl,
        fileName: documentFileName
      };
    }

    try {
      const wageDeterminationDocumentFiles = await buildWageDeterminationSavePayload(wageDocumentsState.files);
      if (wageDeterminationDocumentFiles.length > 0) {
        payload.wageDeterminationDocumentFiles = wageDeterminationDocumentFiles;
      }

      const { error } = await putApi(`${UPDATE_PROJECT}/${projectId}`, payload);
      if (error) {
        errorToast(error);
        return;
      }

      const realRemovedFileIds = wageDocumentsState.removedFileIds.filter(id => id);

      if (realRemovedFileIds.length > 0) {
        const deleteResults = await Promise.all(
          realRemovedFileIds.map(fileId => deleteApi(DELETE_WAGEDETERMINATION_DOCUMENTS(fileId)))
        );

        const deleteWageDocumentsError = deleteResults.find(result => result?.error && result?.statusCode !== 404)?.error;

        if (deleteWageDocumentsError) {
          errorToast(`Project saved, but some documents could not be removed: ${deleteWageDocumentsError}`);
        }
      }

      const descriptionUpdates = buildWageDeterminationDescriptionUpdates(wageDocumentsState.files);

      if (descriptionUpdates.length > 0) {
        try {
          const descriptionUpdateResults = await Promise.all(
            descriptionUpdates.map(update =>
              putApi(UPDATE_WAGEDETERMINATION_FILE_DESCRIPTION(update.projectWageDeterminationFileId), {
                description: update.description
              })
            )
          );

          const descriptionUpdateError = descriptionUpdateResults.find(result => result?.error)?.error;

          if (descriptionUpdateError) {
            errorToast(descriptionUpdateError || "Project saved, but some document labels could not be saved.");
          }
        } catch (descriptionUpdateErr) {
          errorToast("Project saved, but some document labels could not be saved.");
        }
      }

      successToast(`Project ${isAddMode ? "Added" : "Updated"} Successfully`);
      await loadProjectDataForEdit(projectId);
      if (isAddMode) {
        navigate("/projects");
      } else {
        setProjectProfileData(_values);
        onCancel();
      }
    } catch (err) {
      errorToast("Error saving project");
    } finally {
      setStatus(STAUTES.IDLE);
      setIsSaving(false);
    }
  };

  const handleDownload = () => {
    const file = documentPath;
    const link = document.createElement("a");
    link.href = file;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.click();
  };

  useEffect(() => {
    if (isAddMode) {
      loadProjectDataForAdd();
    } else {
      loadProjectDataForEdit(id);
    }
  }, [id, isAddMode]);

  const defaultFormProps = { control, trigger, getValues, setValue, clearErrors, formValues: projectProfileData, handleReadValueClick };

  return (
    <div className="partner-profile">
      <ProFormsLayout
        status={status}
        isSaving={isSaving}
        backAction={backAction}
        title={`${isAddMode ? "Add" : "Edit"} Project`}
        backLabel="Go Back to All Projects"
        beingEdited={isCreator ? isEditModeOn : false}
        onEdit={onEdit}
        onCancel={onCancel}
        onSave={handleSubmit(onSubmit)}
        disableSaveBtn={!projectId}
        hideEdit={hideProjectProfileEditButton}
      >
        {projectInformationNameAndAddressPermission.canView && (
          <ProjectNameAndAddressSection
            defaultFormProps={defaultFormProps}
            formConfig={formConfig}
            permissions={projectInformationNameAndAddressPermission}
            isAddMode={isAddMode}
            enverusProjects={enverusProjects}
            fetchEnverusProjects={fetchEnverusProjects}
            AddNewProjectName={AddNewProjectName}
            handleChangeInProjectSelect={handleChangeInProjectSelect}
            allStates={allStates}
            zipOptions={zipOptions}
            countyOptions={countyOptions}
            cityOptions={cityOptions}
            loadingZip={loadingZip}
            loadingCounty={loadingCounty}
            loadingCity={loadingCity}
            makeFieldAndDependentsEditable={makeFieldAndDependentsEditable}
            wageDocumentsFiles={wageDocumentsState.files}
            wageDocumentsDisabled={!isAddMode && !globalEditMode}
            onWageDocumentAdd={addWageDocument}
            onWageDocumentLabelChange={changeWageDocumentLabel}
            onWageDocumentDelete={deleteWageDocument}
          />
        )}

        {projectSiteInverterDetailPermission.canView && isProjectWorkAreasEnabled && (
          <ProjectSiteInverterDetailSection
            defaultFormProps={defaultFormProps}
            formConfig={formConfig}
            permissions={projectSiteInverterDetailPermission}
            projectId={projectId}
            isCreator={isCreator}
          />
        )}
        
        {projectOwnerShipPermission.canView && (
          <ProjectOwnershipSection
            defaultFormProps={defaultFormProps}
            formConfig={formConfig}
            permissions={projectOwnerShipPermission}
            clients={clients}
          />
        )}
        {projectPartnersPermission.canView && (
          <FormSectionWrapper collapsible title={"Project Partners"}>
            {!!projectId && <ProjectPartners globalEditMode={globalEditMode} setGlobalEditMode={setGlobalEditMode} projectId={projectId} />}
          </FormSectionWrapper>
        )}
        {projectDetailsPermission.canView && (
          <ProjectDetailsSection
            defaultFormProps={defaultFormProps}
            formConfig={formConfig}
            permissions={projectDetailsPermission}
            workTypeList={workTypeList}
            projectKickoff={projectKickoff}
            communitySolarOptions={communitySolarOptions}
            coLocatedProjectOptions={coLocatedProjectOptions}
          />
        )}
        {projectDetailsRequiredInfoPermission.canView && (
          <ProjectDetailsRequestedInfoSection
            defaultFormProps={defaultFormProps}
            formConfig={formConfig}
            permissions={projectDetailsRequiredInfoPermission}
            documentType={documentType}
            handleDateValidation={handleDateValidation}
          />
        )}
        {projectSiteModuleInfoPermission.canView && (
          <ProjectSiteModuleInfoSection defaultFormProps={defaultFormProps} formConfig={formConfig} permissions={projectSiteModuleInfoPermission} />
        )}
        {projectSiteStructedInfoPermission.canView && (
          <ProjectSiteStructureInfoSection
            defaultFormProps={defaultFormProps}
            formConfig={formConfig}
            permissions={projectSiteStructedInfoPermission}
          />
        )}
        
        {projectSiteMaterialPermission.canView && (
          <FormSectionWrapper collapsible defaultClose title={"Project Site: Material & Equipment Scheduling Info"}>
            {!!projectId && <ProjectScheduling globalEditMode={globalEditMode} setGlobalEditMode={setGlobalEditMode} projectId={projectId} isCreator={isCreator} />}
          </FormSectionWrapper>
        )}
        {projectSiteInterconnectionInfoPermission.canView && (
          <ProjectSiteInterconnectionInfoSection
            defaultFormProps={defaultFormProps}
            formConfig={formConfig}
            permissions={projectSiteInterconnectionInfoPermission}
            interconnectionApproval={interconnectionApproval}
            timeKeeping={timeKeeping}
          />
        )}
        {projectSitePermittingAndEntitlementDetailPermission.canView && (
          <ProjectSitePermittingEntitlementSection
            defaultFormProps={defaultFormProps}
            formConfig={formConfig}
            permissions={projectSitePermittingAndEntitlementDetailPermission}
            projectDocumentTypeList={projectDocumentTypeList}
            documentPath={documentPath}
            documentFileName={documentFileName}
            setValue={setValue}
            setDocumentFileName={setDocumentFileName}
            setDocumentUrl={setDocumentUrl}
            handleDownload={handleDownload}
            convertFileToBase64={convertFileToBase64}
            errorToast={errorToast}
          />
        )}
      </ProFormsLayout>
      <ConfirmDialog
        open={open}
        title="Import Project"
        description={`Please confirm to create project "${selectedEnverusProject.label}"`}
        onClose={handleClose}
        onConfirm={handleCreateProject}
      />
      <ConfirmDialog
        open={openWarning}
        title="Warning!"
        description={`"${projectNameWarning}" project already exists. Please choose a different name for the new project.`}
        onClose={handleWarningClose}
        confirmText={null}
        cancelText="Close"
      />
    </div>
  );
}